import React from "react";

import * as DetailList from "~/components/DetailList";
import Issuer from "~/components/Issuer";
import SkeletonDetailList from "~/components/SkeletonDetailList";
import getCountry from "~/data/getCountry";
import { VASP } from "~/types/vaspid";

const EMPTY = "-";

export default function VASPAddress({ vasp }: { vasp?: VASP | null }) {
  return (
    <div>
      <DetailList.Header>
        <DetailList.Item mobile={12}>
          <DetailList.Title as="h2">Business address</DetailList.Title>
        </DetailList.Item>
      </DetailList.Header>

      {vasp ? (
        <DetailList.Content>
          {(vasp.addressLine1
            ? [
                {
                  label: "Address 1",
                  value: vasp.addressLine1,
                  issuer: vasp.issuers?.legalName?.issuerName,
                  issuedDate: vasp.issuers?.legalName?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Address 2",
                  value: vasp.addressLine2,
                  issuer: vasp.issuers?.addressLine2?.issuerName,
                  issuedDate: vasp.issuers?.addressLine2?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "City",
                  value: vasp.city,
                  issuer: vasp.issuers?.city?.issuerName,
                  issuedDate: vasp.issuers?.city?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Country",
                  value: getCountry(vasp.country),
                  issuer: vasp.issuers?.country?.issuerName,
                  issuedDate: vasp.issuers?.country?.issuedDate || vasp.updatedAt,
                },
              ]
            : [
                {
                  label: "Street",
                  value: vasp.street,
                  issuer: vasp.issuers?.street?.issuerName,
                  issuedDate: vasp.issuers?.street?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Building number",
                  value: vasp.number,
                  issuer: vasp.issuers?.number?.issuerName,
                  issuedDate: vasp.issuers?.number?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Suite / Unit Number",
                  value: vasp.unit,
                  issuer: vasp.issuers?.unit?.issuerName,
                  issuedDate: vasp.issuers?.unit?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "City",
                  value: vasp.city,
                  issuer: vasp.issuers?.city?.issuerName,
                  issuedDate: vasp.issuers?.city?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Province / State",
                  value: vasp.state,
                  issuer: vasp.issuers?.state?.issuerName,
                  issuedDate: vasp.issuers?.state?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Postal Code",
                  value: vasp.postCode,
                  issuer: vasp.issuers?.postCode?.issuerName,
                  issuedDate: vasp.issuers?.postCode?.issuedDate || vasp.updatedAt,
                },
                {
                  label: "Country",
                  value: getCountry(vasp.country),
                  issuer: vasp.issuers?.country?.issuerName,
                  issuedDate: vasp.issuers?.country?.issuedDate || vasp.updatedAt,
                },
              ]
          ).map(({ label, value, issuer, issuedDate }) => (
            <DetailList.Item key={label} mobile={12} tablet={6} desktop={3}>
              <DetailList.Term>{label}</DetailList.Term>
              <DetailList.Description className="localize-ignore">{value || EMPTY}</DetailList.Description>
              {value && (
                <Issuer
                  shortLabel={
                    issuer === "VASPnet"
                      ? "VERIFIED BY VASPNET"
                      : issuer === "GLEIF"
                      ? "VERIFIED BY GLEIF"
                      : "SELF-REPORTED"
                  }
                  longLabel={
                    issuer === "VASPnet" || issuer === "GLEIF" ? "VERIFIED INFORMATION" : "SELF-REPORTED INFORMATION"
                  }
                  name={issuer || vasp.name || ""}
                  issuedDate={issuedDate}
                  logo={`/assets/${
                    issuer === "VASPnet" ? "vasp-net-short" : issuer === "GLEIF" ? "gleif" : "self-report-logo"
                  }.svg`}
                />
              )}
            </DetailList.Item>
          ))}
        </DetailList.Content>
      ) : (
        <SkeletonDetailList count={8} />
      )}
    </div>
  );
}
